import(/* webpackMode: "eager", webpackExports: ["AgenticaPageContent"] */ "/vercel/path0/src/app/agentica-sdk/page-content.tsx");
